export const noop = () => {};
export const emptyObj = {};
export const emptyArr = [];

export const PAGE_CONTAINER_ID = 'PAGE_CONTAINER_ID';
